import {post} from './httpBase'
//包车列表
export function rentList(params) {
    return post('/order/tailoredbusorder/searchofmanager', params)
}
//确认订单
export function confirmOrder(params) {
    return post('/order/tailoredbusorder/consentorderdofmanager', params)
}
//获取司机和车牌号
export function driver(params) {
    return post('/order/tailoredbusorder/searchdriverlistofdisptcher', params)
}
//订单详情
export function orderDetail(params) {
    return post('/order/tailoredbusorder/tailoredbusorderdetails', params)
}
//取消订单
export function cancelRent(params) {
    return post('/order/tailoredbusorder/refundofmanager', params)
}


// WEBPACK FOOTER //
// ./src/service/rentService.js